import React, { useState } from 'react';
import { useTranslations } from '@unisporkal/localization';
import { useQueryClient } from '@tanstack/react-query';
import DropboxDownload from '../../DropboxDownload/DropboxDownload';
import MultiDownloads from './MultiDownloads.tsx';
import DownloadsNotZipped from './DownloadsNotZipped.tsx';
import { NotDownloadedAssets } from '../../../../shared/logicalComponents';

import styles from './BatchDownloadForm.module.scss';
import useBatchDownload from '../../../../hooks/queries/useBatchDownload.ts';
import queryKeys from '../../../../support/uiStateKeys';

const BatchDownloadComplete = () => {
  const t = useTranslations();
  const queryClient = useQueryClient();
  const dropboxApp = queryClient.getQueryData([queryKeys.DROPBOX_APP]);
  const {
    response: { downloadDestinations, numAssets },
  } = useBatchDownload();
  const [downloadLocally, setDownloadLocally] = useState(false);
  const isDropboxDownload =
    !downloadLocally && downloadDestinations?.length > 0;
  const dropBoxMessage = t('downloading_to_dropbox', {
    asset_id: numAssets,
    dropbox_folder: dropboxApp,
  });
  const handleDownloadLocallyClick = () => setDownloadLocally(true);

  return (
    <div
      className={styles.completeContainer}
      data-testid="batch-download-complete"
    >
      <NotDownloadedAssets />
      {isDropboxDownload ? (
        <DropboxDownload
          downloadMessage={dropBoxMessage}
          onDownloadLocallyClick={handleDownloadLocallyClick}
        />
      ) : (
        <>
          <MultiDownloads />
          <DownloadsNotZipped />
        </>
      )}
    </div>
  );
};

export default BatchDownloadComplete;
